import { ContactIconProps } from '@/components/molecules/contactLinks'
import { ContactLinkVariants, GridColumns } from '@/types/enums'
import { ButtonProps } from '@/baseComponents'

export function mappedGridColumns(gridColumns: string) {
  switch (gridColumns) {
    case 'One Column':
      return GridColumns.One
    case 'Two Columns':
      return GridColumns.Two
    default:
      return GridColumns.Three
  }
}

export function ContactLinksMapper(
  links: any[],
): ContactIconProps[] | undefined {
  if (!links || links.length === 0) return undefined
  let contactLinks: ContactIconProps[] = []

  const GetUrlValue = (
    value: any,
    linkVariant: string,
  ): { url: string; text: string } => {
    switch (linkVariant) {
      case ContactLinkVariants.Email:
        return { url: `mailto:${value.eMailAddress}`, text: value.eMailAddress }
      case ContactLinkVariants.Phone:
        return { url: `tel:${value.phoneNumber}`, text: value.phoneNumber }
      default:
        return {
          url: `${value.url}`,
          text: linkVariant[0].toUpperCase() + linkVariant.substring(1),
        }
    }
  }

  links.map((link) => {
    const linkProps = GetUrlValue(
      link.content.properties,
      link.content.contentType,
    )

    contactLinks.push({
      contactLinkType: link.content.contentType,
      url: linkProps.url,
      text: linkProps.text,
      target: link.content.target,
    })
  })

  return contactLinks
}

export function LinksMapper(links: any[]): ButtonProps[] {
  let mappedLinks: ButtonProps[] = links?.map((link) => ({
    url: link.url ?? link.route.path,
    text: link.title,
    target: link.target,
  }))

  return mappedLinks
}

export function FooterSocialLinksMapper(
  footerSocialLinkData: any[],
): ContactIconProps[] {
  let contactLinks: ContactIconProps[] =
    footerSocialLinkData?.map((link) => ({
      contactLinkType: link.content.contentType,
      url:
        link.content.properties.url ||
        link.content.properties.eMailAddress ||
        link.content.properties.phoneNumber,
      target: '_blank',
    })) ?? []

  return contactLinks
}
